import { render, staticRenderFns } from "./ProductDetails2.vue?vue&type=template&id=85cd047e"
import script from "./ProductDetails2.vue?vue&type=script&lang=js"
export * from "./ProductDetails2.vue?vue&type=script&lang=js"
import style0 from "./ProductDetails2.vue?vue&type=style&index=0&id=85cd047e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports